import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { v4 } from 'uuid';
import { RadioButton } from '@sunrun/component-library';

const Item = styled.div`
  background-color: white;
  box-shadow: 0px 15px 12px rgba(178, 173, 166, 0.21);
  font-size: 22px;
  margin: 20px 0;

  label {
    padding: 25px;
    cursor: pointer;
  }
`;

export const RadioButtonGroup = ({ items, name, value, onChange }) => {
  const [localValue, setValue] = useState(value);
  const localOnChange = e => {
    setValue(e.target.value);
    onChange(e.target.value);
  };

  return items.map(item => (
    <Item key={v4()}>
      <RadioButton value={item.value} checked={item.value === localValue} name={name} label={item.label} onChange={localOnChange} />
    </Item>
  ));
};

RadioButtonGroup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

RadioButtonGroup.defaultProps = {
  onChange: () => {},
};
